export enum ProfileMobileTabsValues {
  MY_PROFILE = 'myProfile',
  MY_PRIVATE_POSTS = 'myPrivatePosts',
  MY_EQUIPMENT = 'myEquipment',
  MY_TASKS = 'myTasks',
  MY_GOALS = 'myGoals',
}
